import { Col, Row } from "react-bootstrap"
import React, { useEffect, useState } from "react"
import { getJsonGenerateForms } from "../../../../utils/ServicesUtils"
import { useFormikContext } from "formik"
import TabsCustomComponent from "../../../../component/generate-form/generate-custom-component"
import clsx from "clsx"
import { getFormExpand } from "../../../../phan-he-kham-benh/services/PrintExportService";
import { OctGenerateForm } from "@oceantech/oceantech-ui"

type Props = {
    formName: string;
    className?: string;
    action?: any;
    visitId?: string;
}

const DynamicConentTab = ({
    formName,
    className,
    action,
    visitId,
}: Props) => {
    const [dataGenerate, setDataGenerate] = useState<any>();
    const { values, setFieldValue } = useFormikContext<any>();
    const isVisitStopped = values?.visit?.stopped;

    const handleChange = (name: string, value: any) => {
        setFieldValue(`additionalForms.${formName}.${name}`, value);
    };

    const handleGetJsonGenerateForms = async () => {
        try {
            let { data } = await getJsonGenerateForms(formName);
            setDataGenerate(data?.data);
        } catch (error) {
            console.error(error);
        }
    }

    const handleGetFormValue = async () => {
        if (!visitId) return;
        let response = await getFormExpand(visitId, formName);
        if (response?.data?.data) {
            
            setFieldValue(`additionalForms.${formName}`, {
                ...response?.data?.data,
                id: response?.data?.data.id,
        })
        }
    }

    useEffect(() => {
        handleGetJsonGenerateForms();
        handleGetFormValue();
    }, []);

    return (
		<Row className={clsx('spaces p-12 overflow-y-auto bg-white', className)}>
			<Col xl="12" className="h-100">
				<OctGenerateForm
					isView={isVisitStopped}
					listFieldAuto={JSON.parse((dataGenerate?.[formName] as string) || '{}')}
					values={values?.additionalForms}
					onChange={handleChange}
					modelID={formName}
					customComponent={TabsCustomComponent}
				/>
				{action && (
					<div className="position-fixed bottom-0 z-index-1 py-2 w-100 bg-white">
						{action(values, formName)}
					</div>
				)}
			</Col>
		</Row>
	);
}

export default DynamicConentTab